import api from '@/services/api';
import { useQuery } from '@tanstack/react-query';

const useGetUser = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: () => api.user.getUser(),
    staleTime: 1000 * 60 * 5
  });
};

export default useGetUser;
